import {
  collection,
  doc,
} from 'firebase/firestore';

import {
  db,
} from '@/services/firebase.js';

import {
  timeline_child_path,
} from './utils.js';

import {
  converters,
} from '../converters/index.js';

export const timeline_snapshot_refs = {
  document: ({
    workspace_id,
    project_id,
    timeline_id,
    timeline_snapshot_id,
  }) => {
    const path = timeline_child_path({
      is_published: true,
      workspace_id,
      project_id,
      timeline_id,
      collection_name: 'sequenced_timeline_snapshots',
      document_id: timeline_snapshot_id,
    });
    return doc(db, path).withConverter(converters.timeline_snapshots);
  },
  collection: ({
    workspace_id,
    project_id,
    timeline_id,
  }) => {
    const path = timeline_child_path({
      is_published: true,
      workspace_id,
      project_id,
      timeline_id,
      collection_name: 'sequenced_timeline_snapshots',
    });
    return collection(db, path).withConverter(converters.timeline_snapshots);
  },
};
